import * as React from 'react'
import Snackbar from '@mui/material/Snackbar'
import CloseIcon from '@mui/icons-material/Close';

export default function PositionedSnackbar({
  severity = 'info',
  vertical = 'top',
  horizontal = 'right',
  open = false,
  message = '',
  handleClose
}) {

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        message={message}
        key={vertical + horizontal}
        severity='info'
        action={<CloseIcon fontSize='small' sx={{ cursor: 'pointer' }} onClick={handleClose} />}
      />
    </div>
  )
}
